import { baseEnvironment } from './environment.base';
import { EnvironmentModel } from '@privanot/shared-models';

export const environment: EnvironmentModel = {
    ...baseEnvironment,
    name: 'dev',
    BASE_URL: 'https://api-dev.t3p.be',
    isDevelopment: true,
    isProduction: false,
    featureFlags: { deviceApprovals: false },
};
